import NewUserPage from "./NewUserPage";

const page = NewUserPage;
export default page;
